import React from 'react';
import { Breadcrumb } from '../../../shared/web/layout/Breadcrumbs';
import { SettingsBreadcrumbs } from '../../settingsModule';
import useSettingsNavigator from '../../settingsNavigator';
import { useStatesHelper } from 'features/tasks-forms';

export default function SetupAreasStateBreadcrumbs(props: {
  state?: string,
  children?: React.ReactNode
}) {

  const statesHelper = useStatesHelper();
  const settingsNavigator = useSettingsNavigator();

  return (
    <SettingsBreadcrumbs>
      <Breadcrumb text="Markets Administration" href="/admin/setupareas">
        <Breadcrumb
          text={props.state ? statesHelper.getLabelByValue(props.state) : 'Without State'}
          href={settingsNavigator.getAdminStateMarketsLink(props.state)}
        >
          {props.children}
        </Breadcrumb>
      </Breadcrumb>
    </SettingsBreadcrumbs>
  );
}
